import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import RichTextEditor from "react-rte";
import { Button } from "reactstrap";
import moment from "moment";
import { API_END_POINT } from "../config";
import Cookie from "js-cookie";
const token = Cookie.get("waffle_world_access_token");

import { DateRangePicker } from "react-dates";
import "react-dates/initialize";

import Select from "react-select";
import "react-select/dist/react-select.css";

export default class VideoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      video: {
        name: "",
        videoUrl: "",
        description: "",
        previewImage: "",
      },
      hotels: [],
      hotel: "",
      startDate: null,
      endDate: null,
      focusedInput: null,
      description: RichTextEditor.createEmptyValue(),
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.postCovervideo = this.postCovervideo.bind(this);
  }

  componentDidMount() {
    console.log("props", this.props);
    const { match } = this.props;
    if (match.params.videoId) {
      axios
        .get(`${API_END_POINT}/api/videos/one`, {
          params: { videoId: match.params.videoId },
          headers: { "auth-token": token },
        })
        .then((response) => {
          this.setState(
            {
              video: response.data.object[0],
            },
            () => {}
          );
        });
    }
  }

  setHotel(selectedHotel) {
    this.setState((prevState) => ({
      hotel: selectedHotel,
      video: {
        ...prevState.video,
        hotel_id: selectedHotel.ID,
      },
    }));
  }

  setDescription(description) {
    const { video } = this.state;
    video.description = description.toString("html");
    this.setState({
      video,
      description,
    });
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    const { video } = this.state;
    video[name] = value;
    this.setState({ video });
  }

  handleImages = (event) => {
    const { name } = event.target;
    const { video } = this.state;
    video[name] = event.target.files[0];
    this.setState({ video });
  };

  postCovervideo(event) {
    event.preventDefault();
    const { match, history } = this.props;
    const { loading, video } = this.state;
    this.setState({ loading: true });

    if (match.params.videoId) {
      delete video["_id"];
      video.videoId = match.params.videoId;
    }

    const fd = new FormData();
    Object.keys(video).forEach((eachState) => {
      fd.append(`${eachState}`, video[eachState]);
    });

    if (match.params.videoId) {
      delete video["_id"];
      delete video["userId"];
      delete video["date"];
      delete video["__v"];
      this.setState({ video });
      axios
        .post(`${API_END_POINT}/api/videos/update`, fd, {
          headers: { "auth-token": token },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.msg);
            this.setState({ loading: false });
            this.props.history.goBack();
          } else {
            window.alert("ERROR");
            this.setState({ loading: false });
          }
        });
    } else {
      axios
        .post(`${API_END_POINT}/api/videos`, fd, {
          headers: { "auth-token": token },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.msg);
            this.setState({ loading: false });
            this.props.history.goBack();
          } else {
            window.alert("ERROR");
            this.setState({ loading: false });
          }
        });
    }
  }

  render() {
    const { loading, video } = this.state;
    console.log(this.state);

    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Enter video Details</h2>
                </div>
                <div className="x_content">
                  <br />
                  <form
                    id="demo-form2"
                    data-parsley-validate
                    className="form-horizontal form-label-left"
                    onSubmit={this.postCovervideo}
                  >
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Name
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="name"
                          className="form-control"
                          value={video.name}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Beschreibung
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="description"
                          className="form-control"
                          value={video.description}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    {/* <div className="form-group row">
                      <label
                        className="control-label col-md-3 col-sm-3"
                      >Video
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="video"
                          className="form-control"
                          value={video.video}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div> */}

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Video
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="video/*"
                          name="videoUrl"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Bild Vorschau
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="previewImage"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required
                        />
                      </div>
                    </div>

                    <div className="ln_solid" />
                    <div className="form-group row">
                      <div className="col-md-6 col-sm-6 offset-md-3">
                        <Button
                          className={`btn btn-success btn-lg ${
                            this.state.loading ? "disabled" : ""
                          }`}
                        >
                          <i
                            className={`fa fa-spinner fa-pulse ${
                              this.state.loading ? "" : "d-none"
                            }`}
                          />{" "}
                          Bestätigen
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/VideoForm.jsx